module.exports = { 
    q1:{
      dataQuestion :
      {
        type:"Radio",
        th : { 
              question : "ท่านเป็นผู้นำรถยนต์นิสสันคันนี้เข้ารับบริการ ที่ศูนย์ซ่อมสีและตัวถัง นิสสัน <?{branch_name}?>",
              question_agent : "ท่านเป็นผู้นำรถยนต์นิสสันคันนี้เข้ารับบริการ ที่ศูนย์ซ่อมสีและตัวถัง นิสสัน <?{branch_name}?>",
              answer : [
                {
                    name : "ใช่",
                    value : "1",
                    showRemark : false
                },
                {
                    name : "ไม่ใช่",
                    value : "2",
                    showRemark : false
                }  
              ]
        },
        en : { 
              question : "",
              question_agent : "",
              answer : [
                {
                    name : "Yes",
                    value : "1",
                    showRemark : false
                },
                {
                    name : "No",
                    value : "2",
                    showRemark : false
                }, 
              ]
        }
      }
    },
    q2:{
      dataQuestion :
      {
        type:"Radio",
        th : { 
              question : "การเข้ารับบริการครั้งนี้ ท่านทำการนัดหมายก่อนเข้าซ่อมสีและตัวถังหรือไม่",
              question_agent : "การเข้ารับบริการครั้งนี้ ท่านทำการนัดหมายก่อนเข้าซ่อมสีและตัวถังหรือไม่",
              answer : [
                {
                    name : "ใช่",
                    value : "1",
                    showRemark : false
                },
                {
                    name : "ไม่ใช่",
                    value : "2",
                    showRemark : false
                }  
              ]
        },
        en : { 
          question : "",
          question_agent : "",
          answer : [
            {
                name : "Yes",
                value : "1",
                showRemark : false
            },
            {
                name : "No",
                value : "2",
                showRemark : false
            }, 
          ]
        }
      }
    }, 
    q3:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"กรุณาให้คะแนนความพึงพอใจโดยรวม จากประสบการณ์การเข้ารับบริการที่ศูนย์ซ่อมสีและตัวถังแห่งนี้", 
              question_agent:"กรุณาให้คะแนนความพึงพอใจโดยรวม จากประสบการณ์การเข้ารับบริการที่ศูนย์ซ่อมสีและตัวถังแห่งนี้", 
              answer:[0,1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[0,1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q4:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ท่านจะแนะนำศูนย์ซ่อมสีและตัวถังแห่งนี้ กับเพื่อน, ญาติ หรือสมาชิกในครอบครัวหรือไม่ โดยใช้ระดับคะแนนจาก 0-10 โดยที่ 0 หมายถึง “ไม่แนะนำแน่นอน” และ 10 หมายถึง แนะนำแน่นอน", 
              question_agent:"ท่านจะแนะนำศูนย์ซ่อมสีและตัวถังแห่งนี้ กับเพื่อน, ญาติ หรือสมาชิกในครอบครัวหรือไม่ โดยใช้ระดับคะแนนจาก 0-10 โดยที่ 0 หมายถึง “ไม่แนะนำแน่นอน” และ 10 หมายถึง แนะนำแน่นอน", 
              answer:[0,1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[0,1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q5:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ความสะดวกในการติดต่อ หรือนัดหมายเข้ารับบริการศูนย์ซ่อมสีและตัวถัง", 
              question_agent:"ความสะดวกในการติดต่อ หรือนัดหมายเข้ารับบริการศูนย์ซ่อมสีและตัวถัง", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q6:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"กรณีที่ทางศูนย์ซ่อมสีและตัวถังไม่สามารถรับรถเข้าซ่อมได้ทันที มีเจ้าหน้าที่โทรติดตามหรือนัดหมายเพื่อนำรถเข้าซ่อมหรือไม่", 
              question_agent:"กรณีที่ทางศูนย์ซ่อมสีและตัวถังไม่สามารถรับรถเข้าซ่อมได้ทันที มีเจ้าหน้าที่โทรติดตามหรือนัดหมายเพื่อนำรถเข้าซ่อมหรือไม่", 
              answer:[
                { name:"มี", value:"1",showRemark : false},
                { name:"ไม่มี", value:"2",showRemark : false},
                { name:"เข้าซ่อมได้ทันที", value:"3",showRemark : false}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:" ",  
              answer:[
                { name:"มี", value:"1",showRemark : false},
                { name:"ไม่มี", value:"2",showRemark : false},
                { name:"เข้าซ่อมได้ทันที", value:"3",showRemark : false}
              ]
        },
      }
    },
    q7:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ระยะเวลาที่ใช้ในขั้นตอนการมอบรถยนต์ให้กับทางศูนย์ซ่อมสีและตัวถัง (เวลาที่ต้องรอเจ้าหน้าที่เข้ามาต้อนรับ, พูดคุยกับเจ้าหน้าที่รับรถ และรับเอกสารใบรับรถ)", 
              question_agent:"ระยะเวลาที่ใช้ในขั้นตอนการมอบรถยนต์ให้กับทางศูนย์ซ่อมสีและตัวถัง (เวลาที่ต้องรอเจ้าหน้าที่เข้ามาต้อนรับ, พูดคุยกับเจ้าหน้าที่รับรถ และรับเอกสารใบรับรถ)", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:" ",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q8:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"เมื่อท่านไปถึงศูนย์ซ่อมสีและตัวถัง ที่ปรึกษาด้านบริการได้เข้ามาต้อนรับทันที", 
              question_agent:"เมื่อท่านไปถึงศูนย์ซ่อมสีและตัวถัง ที่ปรึกษาด้านบริการได้เข้ามาต้อนรับทันที", 
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
      }
    },
    q9:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ความพึงพอใจโดยรวมต่อที่ปรึกษาด้านบริการ ด้านความสุภาพ, กระตือรือร้น และความครบถ้วนในการอธิบาย", 
              question_agent:"ความพึงพอใจโดยรวมต่อที่ปรึกษาด้านบริการ ด้านความสุภาพ, กระตือรือร้น และความครบถ้วนในการอธิบาย", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q10:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"ที่ปรึกษาด้านบริการได้แจ้งประเมินราคา และระยะเวลาที่จะใช้บริการ ก่อนเข้าซ่อมหรือไม่", 
              question_agent:"ที่ปรึกษาด้านบริการได้แจ้งประเมินราคา และระยะเวลาที่จะใช้บริการ ก่อนเข้าซ่อมหรือไม่", 
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
      }
    },
    q11:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ความพึงพอใจโดยรวมต่อ สิ่งอำนวยความสะดวก, อาหารว่างและเครื่องดื่ม และความสะอาดของบริเวณรับรถและพื้นที่โดยรวม", 
              question_agent:"ความพึงพอใจโดยรวมต่อ สิ่งอำนวยความสะดวก, อาหารว่างและเครื่องดื่ม และความสะอาดของบริเวณรับรถและพื้นที่โดยรวม", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q12:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ความยุติธรรมในการคิดค่าบริการ เทียบกับคุณภาพการบริการ", 
              question_agent:"ความยุติธรรมในการคิดค่าบริการ เทียบกับคุณภาพการบริการ", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q13:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"ได้รับการอธิบายเกี่ยวกับรายละเอียดค่าใช้จ่าย หลังให้บริการเสร็จแล้วอย่างชัดเจน", 
              question_agent:"ได้รับการอธิบายเกี่ยวกับรายละเอียดค่าใช้จ่าย หลังให้บริการเสร็จแล้วอย่างชัดเจน", 
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
      }
    },
    q14:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"ศูนย์ซ่อมสีและตัวถัง ได้ชี้แจงจุดที่ทำการเปลี่ยนอะไหล่ หรือทำการซ่อมที่ตัวรถให้แก่ท่านหรือไม่", 
              question_agent:"ศูนย์ซ่อมสีและตัวถัง ได้ชี้แจงจุดที่ทำการเปลี่ยนอะไหล่ หรือทำการซ่อมที่ตัวรถให้แก่ท่านหรือไม่", 
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่แน่ใจ", value:"3"}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"},
                { name:"ไม่แน่ใจ", value:"3"}
              ]
        },
      }
    },
    q15:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ความรวดเร็วในขั้นตอนการรับรถคืน", 
              question_agent:"ความรวดเร็วในขั้นตอนการรับรถคืน", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q16:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"ระยะเวลาที่ใช้ทั้งสิ้นในการบริการรถของท่าน", 
              question_agent:"ระยะเวลาที่ใช้ทั้งสิ้นในการบริการรถของท่าน", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:" ",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q17:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"มีเจ้าหน้าที่แจ้งให้ท่านทราบถึงสถานะการซ่อมของรถท่านหรือไม่", 
              question_agent:"มีเจ้าหน้าที่แจ้งให้ท่านทราบถึงสถานะการซ่อมของรถท่านหรือไม่", 
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"มี", value:"1"},
                { name:"ไม่มี", value:"2"}
              ]
        },
      }
    },
    q18:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"คุณภาพงานซ่อม/บำรุงรักษา ได้รับการแก้ไขครบถ้วนตามที่แจ้งซ่อม", 
              question_agent:"คุณภาพงานซ่อม/บำรุงรักษา ได้รับการแก้ไขครบถ้วนตามที่แจ้งซ่อม", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q19:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"การบริการครั้งนี้ได้รับการซ่อมแก้ไขได้ถูกต้องภายในครั้งเดียวใช่หรือไม่", 
              question_agent:"การบริการครั้งนี้ได้รับการซ่อมแก้ไขได้ถูกต้องภายในครั้งเดียวใช่หรือไม่", 
              answer:[
                { name:"ใช่", value:"1"},
                { name:"ไม่ใช่", value:"2"},
                { name:"ยังไม่อนุมัติให้ซ่อม หรือไม่ทราบ", value:"3"} 
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"ใช่", value:"1"},
                { name:"ไม่ใช่ (ไปข้อ 20)", value:"2"},
                { name:"ยังไม่อนุมัติให้ซ่อม หรือไม่ทราบ", value:"3"}  
              ]
        },
      }
    },
    q20:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"ศูนย์ซ่อมสีและตัวถังไม่สามารถแก้ไขได้ในครั้งเดียวเพราะเหตุผลใด", 
              question_agent:"ศูนย์ซ่อมสีและตัวถังไม่สามารถแก้ไขได้ในครั้งเดียวเพราะเหตุผลใด", 
              answer:[
                { name:"ศูนย์ซ่อมสีและตัวถังไม่ได้ทำการซ่อมรายการนั้น (เช่น ลืม, เวลาซ่อมไม่พอ, ปฏิเสธการซ่อม)", value:"1" ,showRemark : false}, 
                { name:"ศูนย์ซ่อมสีและตัวถังไม่มีอะไหล่", value:"2",showRemark : false}, 
                { name:"ศูนย์บริการไม่พบอาการขณะตรวจสอบ", value:"3",showRemark : false}, 
                { name:"มีปัญหาใหม่เกิดขึ้น หลังเข้ารับบริการครั้งก่อน", value:"4",showRemark : false}, 
                { name:"เกิดปัญหาเดิมซ้ำหลังจากที่ศูนย์ซ่อมสีและตัวถังแก้ไขแล้ว", value:"5",showRemark : false}, 
                { name:"อื่นๆ", value:"6" , showRemark : true}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[ 
                { name:"ศูนย์ซ่อมสีและตัวถังไม่ได้ทำการซ่อมรายการนั้น (เช่น ลืม, เวลาซ่อมไม่พอ, ปฏิเสธการซ่อม)", value:"1" ,showRemark : false}, 
                { name:"ศูนย์ซ่อมสีและตัวถังไม่มีอะไหล่", value:"2",showRemark : false}, 
                { name:"ศูนย์บริการไม่พบอาการขณะตรวจสอบ", value:"3",showRemark : false}, 
                { name:"มีปัญหาใหม่เกิดขึ้น หลังเข้ารับบริการครั้งก่อน", value:"4",showRemark : false}, 
                { name:"เกิดปัญหาเดิมซ้ำหลังจากที่ศูนย์ซ่อมสีและตัวถังแก้ไขแล้ว", value:"5",showRemark : false}, 
                { name:"อื่นๆ", value:"6" , showRemark : true}
              ]
        },
      }
    }, 
    q21:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"สภาพและความสะอาดของรถยนต์หลังการซ่อม", 
              question_agent:"สภาพและความสะอาดของรถยนต์หลังการซ่อม", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q22:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"รถของท่านได้รับการล้างทำความสะอาด เมื่อได้รับรถคืนหรือไม่", 
              question_agent:"รถของท่านได้รับการล้างทำความสะอาด เมื่อได้รับรถคืนหรือไม่", 
              answer:[
                { name:"ใช่ ทั้งล้างและดูดฝุ่น", value:"1"}, 
                { name:"ล้างอย่างเดียว", value:"2"}, 
                { name:"ดูดฝุ่นอย่างเดียว", value:"3"}, 
                { name:"ไม่ได้ล้างและดูดฝุ่น", value:"4"}, 
                { name:"ไม่ได้ล้าง (เพราะท่านไม่ต้องการล้างรถ)", value:"5"}, 
                { name:"ไม่ทราบ", value:"6"}
              ]
        },
        en :  {  
              question:"",  
              question_agent:"",  
              answer:[
                { name:"ใช่ ทั้งล้างและดูดฝุ่น", value:"1"}, 
                { name:"ล้างอย่างเดียว", value:"2"}, 
                { name:"ดูดฝุ่นอย่างเดียว", value:"3"}, 
                { name:"ไม่ได้ล้างและดูดฝุ่น", value:"4"}, 
                { name:"ไม่ได้ล้าง (เพราะท่านไม่ต้องการล้างรถ)", value:"5"}, 
                { name:"ไม่ทราบ", value:"6"}
              ]
        },
      }
    },
    q23:{
      dataQuestion : {
        type:"QButtonPoint",
        th : {  
              question:"กรุณาให้คะแนนความพึงพอใจที่มีต่อการติดตามผลหลังการซ่อมของศูนย์ซ่อมสีและตัวถัง", 
              question_agent:"กรุณาให้คะแนนความพึงพอใจที่มีต่อการติดตามผลหลังการซ่อมของศูนย์ซ่อมสีและตัวถัง", 
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[1,2,3,4,5,6,7,8,9,10]
        },
      }
    },
    q24:{
      dataQuestion : {
        type:"Radio",
        th : {  
              question:"ศูนย์ซ่อมสีและตัวถังมีการติดตามผลหลังการซ่อมหรือไม่", 
              question_agent:"ศูนย์ซ่อมสีและตัวถังมีการติดตามผลหลังการซ่อมหรือไม่", 
              answer:[
                { name:"ใช่", value:"1"},
                { name:"ไม่ใช่", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"ใช่", value:"1"},
                { name:"ไม่ใช่", value:"2"},
                { name:"ไม่ทราบ,ไม่แน่ใจ", value:"3"}
              ]
        },
      }
    },
    q25:{
      dataQuestion : {
        type:"Input",
        th : {  
              question:"จากการเข้ารับบริการครั้งนี้ กรุณาให้ข้อคิดเห็น หรือคำแนะนำในการปรับปรุงการให้บริการให้ดีขึ้น", 
              question_agent:"จากการเข้ารับบริการครั้งนี้ กรุณาให้ข้อคิดเห็น หรือคำแนะนำในการปรับปรุงการให้บริการให้ดีขึ้น", 
              rows:4
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              rows:4
        },
      }
    },
    q26:{
      dataQuestion : {
        type:"QRadio",
        th : {  
              question:"ท่านต้องการให้เจ้าหน้าที่ติดต่อกลับเกี่ยวกับข้อเสนอแนะของท่านหรือไม่", 
              question_agent:"ท่านต้องการให้เจ้าหน้าที่ติดต่อกลับเกี่ยวกับข้อเสนอแนะของท่านหรือไม่", 
              answer:[
                { name:"ต้องการ", value:"1"},
                { name:"ไม่ต้องการ", value:"2"},
                // { name:"คะแนน OS1 สูงกว่าเกณฑ์ที่กำหนด", value:"3"} 
              ]
        },
        en :  {  
              question:" ",  
              question_agent:"",  
              answer:[
                { name:"ต้องการ", value:"1"},
                { name:"ไม่ต้องการ", value:"2"},
                // { name:"คะแนน OS1 สูงกว่าเกณฑ์ที่กำหนด", value:"3"} 
              ]
        },
      }
    },
};